import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_BASE } from '../../core/constants';
import { HttpUtils } from '../../shared/http-utils';
import { Health } from './health';
import { Metrics } from './metrics';
import { map } from 'rxjs/operators';

@Injectable()
export class MonitorService {

  constructor(private http: HttpClient) {
  }

  public health(): Observable<Health> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/health`;
    return this.http.get(url, { headers })
      .pipe(
        map(h => Health.fromDto(h))
      );
  }

  public metrics(): Observable<Metrics> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/metrics`;
    return this.http.get(url, { headers })
      .pipe(
        map(h => Metrics.fromDto(h))
      );
  }

  public trace(): Observable<any> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/trace`;
    return this.http.get(url, { headers })
      .pipe(
        map((traces: any[]) => traces
          .filter((t: any) => t.info.method !== 'OPTIONS')
          .map((t: any) => {
            t.showFullTrace = false;
            return t;
          })
        )
      );
  }

}
